var _style, _circle, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQtum(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2E9AD0;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 150,
    cy: 150,
    r: 150
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lines"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M174.4,247.4h-63.2l-51-37.4l-19.4-60.4l19.4-60.4l51-37.4h63.2l51,37.4l19.4,60.4L225.4,210l-0.7,0.7 L174.4,247.4L174.4,247.4z M112.6,243H173l48.9-35.9l18.7-57.5l-18.7-57.5L173,56.3h-60.4L63.8,92.2l-18.7,57.5l18.7,57.5 L112.6,243L112.6,243z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M252,237.3l-29.5-26.6l-28.8-10.8l-51,6.5l-51.7-6.5l-28.8,10.8l-1.4-4.3l29.4-11.5h0.8l51.7,7.2l51.7-7.2 l0.7,0.7l30.2,11.5l29.4,27.3L252,237.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M173,249.5l-30.2-41.7l-31.6,41.7l-23-51l4.3-2.2l20.1,44.6l30.2-41l29.5,41l20.1-44.6l27.3-54.6l6.5,66.8 h-4.3l-5.1-51l-20.1,41L173,249.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43.7,147.5h199.7v4.3H43.7V147.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M219.7,157.5L194.6,108L173,154.7l-30.2-53.9l-30.9,53.9L90.4,108l-25.1,49.6l-5.8-66.1l4.3-0.7l4.3,51.7 l22.2-43.8l21.6,46.7l30.9-53.2l29.5,53.2l22.3-46.7l22.2,43.1l3.6-51h4.3L219.7,157.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M192.4,104.4l-20.1-45.3l-29.5,41.7l-30.2-41.7l-20.1,45.3l-3.6-2.1l22.3-51.7l31.6,42.4L173,50.5l23.7,51.7 L192.4,104.4z M221.8,208.5l-5.1-51l-22.2,44.6l-22.3-47.4l-29.5,53.9l-30.9-53.9l-21.6,47.4l-22.2-44.6l-4.3,51h-4.3l5.8-66.8 L90.4,192l21.6-46.7l30.9,53.9l30.2-53.9l21.6,47.4l25.1-51l6.5,66.8L221.8,208.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M194.6,105.8l-52.5-7.2l-51.7,7.2l-29.4-13l1.4-4.3l28.8,12.2l51-6.4l52.5,6.4l28-12.2l2.2,4.3L194.6,105.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Circles"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 111.9,
    cy: 245.2,
    r: 8.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 172.3,
    cy: 245.2,
    r: 8.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 111.9,
    cy: 54.8,
    r: 8.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 172.3,
    cy: 54.8,
    r: 8.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 222.6,
    cy: 90.8,
    r: 8.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 61.6,
    cy: 90.8,
    r: 8.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 61.6,
    cy: 209.3,
    r: 8.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 43.7,
    cy: 149.6,
    r: 8.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1602 -0.9871 0.9871 0.1602 56.0795 365.2031)",
    className: "st1",
    cx: 242.7,
    cy: 149.6,
    rx: 8.6,
    ry: 8.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 218.3,
    cy: 149.6,
    r: 8.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 66.7,
    cy: 149.6,
    r: 8.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 111.9,
    cy: 149.6,
    r: 8.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 172.3,
    cy: 149.6,
    r: 8.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 142.8,
    cy: 96.5,
    rx: 8.6,
    ry: 8.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 90.4,
    cy: 103.7,
    r: 8.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 194.6,
    cy: 103.7,
    r: 8.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 142.8,
    cy: 204.2,
    r: 8.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 90.4,
    cy: 197,
    r: 8.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 194.6,
    cy: 197,
    r: 8.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 253.4,
    cy: 235.9,
    r: 11.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQtum);
export default __webpack_public_path__ + "static/media/QTUM.159acc249c23c6f3d1efdd8e6835c81c.svg";
export { ForwardRef as ReactComponent };